export default "__VITE_ASSET__jgBZt_7e__"